import Circuit from "~/components/circuit"

const json = [
  {
    name: "mixed3a",
    modules: [
      {
        name: "Early Curves",
        neurons: [95, 145, 147, 189, 92, 71, 104, 81, 137],
      },
      {
        name: "Angles",
        neurons: [116, 77, 176, 149, 100],
      },
    ],
  },
  {
    name: "mixed3b",
    modules: [
      {
        name: "Curve Detectors",
        neurons: [379, 406, 385, 343, 342, 388, 340, 330, 349, 324],
      },
    ],
  },
]

export default class IncomingCircuit extends Component {
  render() {
    return (
      <Surface marginBottom={30} marginTop={-10}>
        <Circuit circuit={json} inlineLayerNames />
        <Text alignSelf="center" fontStyle="italic" marginTop={10}>
          The circuit of neurons going from 3a to the curve detectors in 3b that
          we will be exploring thoroughly.
        </Text>
      </Surface>
    )
  }
}
